/**
 * ### [Route for ('/projects')]
 * 
 * Shows the list of projects using tables along with the filters and expandable rows
 */

import { RouteButton } from "../../Buttons"
import { GenericTableFactory } from "../../_Shared/Table/Classes/Factory"

export function ProjectList() {
    const table = GenericTableFactory.createProjectTable()

    return(
        <>
            <div className="pt-5 pl-5">
                <h1>Projects</h1>
            </div>

            {table.RenderTable()}

            <div className="flex flex-row justify-center gap-3 m-2">
                <RouteButton route={"/main_menu"} text="Back"/>
            </div>

        </>
    )
}

export function MiniProjectList() {
    const table = GenericTableFactory.createMiniProjectTable()

    return(
        <>
            {table.RenderTable()}
        </>
    )
}

export function FinanceProjectList() {
    const table = GenericTableFactory.createFinanceProjectTable()

    return(
        <>
            <div className="pt-5 pl-5">
                <h1>Projects</h1>
            </div>

            {table.RenderTable()}

            <div className="flex flex-row justify-center gap-3 m-2">
                <RouteButton route={"/main_menu"} text="Back"/>
            </div>
        </>
    )
}